const formats = [
  { label: 'Slider', color: '#234DFF', value: 1 },
  // { label: 'Interstitial', color: '#BF56FF', value: 2 },
  { label: 'InPage', color: '#6456FF', value: 3 },
  { label: 'VPAID',color: '#568FFF', value: 4 },
  { label: 'Floating', color: '#877dfb', value: 5 },
  { label: 'AdWall', color: '#00ffe0', value: 7 },
  { label: 'Branding', color: '#73ea66', value: 8 },
  { label: 'Curtain', color: '#ff9a3c', value: 9 },
] as const;

export default formats;
